<template>
  <div>
    <div id="components-form-demo-advanced-search">
      <a-form layout="inline" class="ant-advanced-search-form">
        <a-row>
          <a-col :span="6">
            <a-form-item label="商品名称">
              <a-input size="small" v-model="queryParam.query_name_like" placeholder="商品名称" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="所属品牌">
              <a-select
                size="small"
                v-model="queryParam.query_brandId_eq"
                defaultValue
                width="200px"
              >
                <a-select-option value>----请选择----</a-select-option>
                <a-select-option
                  v-for="option in brandList"
                  v-bind:key="option.value"
                >{{ option.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="所属分类">
              <a-select
                size="small"
                v-model="queryParam.query_groupUid_eq"
                defaultValue
                style="width:200px"
              >
                <a-select-option value>----请选择----</a-select-option>
                <a-select-option
                  v-for="option in productGroup"
                  v-bind:key="option.value"
                >{{ option.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :span="6">
              <a-form-item label="商品状态">
                <a-select
                  size="small"
                  v-model="queryParam.query_state_eq"
                  defaultValue
                  style="width:200px"
                >
                  <a-select-option value>--请选择--</a-select-option>
                  <a-select-option
                    v-for="option in productStateList"
                    v-bind:key="option.value"
                  >{{ option.text }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="说明">
                <a-input size="small" v-model="queryParam.query_note_like" placeholder="说明" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="规格">
                <a-input
                  size="small"
                  v-model="queryParam.query_specification_like"
                  placeholder="规格"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden', } || {} "
            >
              <a-button size="small" type="primary" @click="reloadTable">查询</a-button>
              <a-button style="margin-left: 8px" size="small" @click="queryParamRest">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <p></p>
    <div class="table-operations">
      <a-button size="small" type="primary" @click="goToAdd">添加</a-button>
      <p></p>
    </div>
    <a-table
      ref="table"
      bordered
      :columns="columns"
      rowKey="id"
      :dataSource="data"
      :pagination="pagination"
      :pageSizeOptions="pagination.pageSizeOptions"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <!-- <a-button size="small" @click="goToUpdate(record.id)">上传封面图片</a-button> -->

        <a-divider type="vertical" />
        <a-button size="small" @click="goToUpdate(record.id)">修改</a-button>
        <a-divider type="vertical" />
        <a-button size="small" type="danger" @click="deleteById(record.id)">删除</a-button>
        <a-divider type="vertical" />
        <a-upload
          v-bind:action="httpRoot+'/api/1.0/file/upload'"
          :showUploadList="false"
          @change="handleUploadFileChange($event,record)"
        >
          <a-button size="small">上传封面图片</a-button>
        </a-upload>
      </span>
      <span slot="brandInfo" slot-scope="text">{{text | dictText(brandList)}}</span>
      <span slot="groupUid" slot-scope="text">{{text | dictText(productGroup)}}</span>
      <span
        slot="taxPriceAction"
        slot-scope="text,record"
      >{{getTaxFreeOrTaxPrice(record,'TaxPrice')}}</span>
      <span
        slot="taxFreePriceAction"
        slot-scope="text,record"
      >{{getTaxFreeOrTaxPrice(record,'TaxFreePrice')}}</span>
      

      <span slot="picture" slot-scope="text">
        <a-avatar
          v-if="text!=null && text!=''"
          shape="square"
          :size="120"
          v-bind:src="httpRoot+'/'+text"
        />
      </span>
      <span slot="productState" slot-scope="text,record">
        <a-select
          :defaultValue="''+record.state"
          style="width: 120px"
          @change="updateProduct({state:$event,id:record.id})"
        >
          <a-select-option v-for="option in productStateList" :key="option.value">{{ option.text }}</a-select-option>
        </a-select>
      </span>
    </a-table>
  </div>
</template>
<script>
export default {
  name: "productIndex",
  mounted() {},
  created() {
    this.$http.get("/api/1.0/productPrice/list").then(res => {
      this.productPriceList = res.data;
    });
    this.$http
      .get("/api/1.0/dict/list", { "query-ownGroup-eq": "ProductState" })
      .then(res => {
        this.productStateList = res.data;
      });
    this.$http.get("api/1.0/brand/list").then(res => {
      this.brandList = res.data;
    });
    this.$http.get("/api/1.0/productGroup/list").then(res => {
      this.productGroup = res.data;
    });
    this.queryParamRest();
  },
  data() {
    return {
      productPriceList: [],
      productGroup: [],
      httpRoot: this.$defines.hostRoot,
      productStateList: [],
      brandList: [],
      advanced: false,
      queryParam: {},
      data: [], //渲染表格数据
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        current: 1,
        defaultCurrent: 1,
        pageSize: 10,
        defaultPageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `Total ${total} items`
      },
      loading: false,
      columns: [
        {
          title: "商品名称",
          dataIndex: "name",
          sorter: true
        },
        {
          title: "封面图片",
          dataIndex: "picture",
          scopedSlots: { customRender: "picture" }
        },
        {
          title: "售价",
          dataIndex: "price",
          align: "right",
          sorter: true
        },
        {
          title: "带票价格",
          dataIndex: "taxPrice",
          align: "right",
          scopedSlots: { customRender: "taxPriceAction" }
        },
        {
          title: "不带票价格",
          dataIndex: "taxFreePrice",
          align: "right",
          scopedSlots: { customRender: "taxFreePriceAction" }
        },
        {
          title: "商品状态",
          dataIndex: "state",
          sorter: true,
          scopedSlots: { customRender: "productState" }
        },
        {
          title: "所属分类",
          dataIndex: "groupUid",
          sorter: true,
          scopedSlots: { customRender: "groupUid" }
        },
        {
          title: "所属品牌",
          dataIndex: "brandId",
          sorter: true,
          scopedSlots: { customRender: "brandInfo" }
        },
        {
          title: "规格",
          dataIndex: "specification",
          sorter: true
        },
        {
          title: "说明",
          dataIndex: "note"
        },
        // {
        //   title: "操作时间",
        //   dataIndex: "updateTime",
        //   sorter: true
        // },
        {
          title: "操作",
          key: "action",

          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.fetch(
        this.$http.initParams(pagination, filters, sorter, this.queryParam)
      );
    },
    fetch(params = {}) {
      this.loading = true;
      this.$http.get("/api/1.0/product/page", params).then(res => {
        const data = res.data;
        this.data = data.records;
        const pagination = { ...this.pagination };
        pagination.total = data.total;
        pagination.pageSize = data.size;
        pagination.current = data.current;
        this.pagination = pagination;
      });
      this.loading = false;
    },
    onShowSizeChange: () => {
      this.pagination.pageSize = pageSize;
    },

    queryParamRest() {
      this.queryParam = {
        query_state_eq: "",
        query_brandId_eq: "",
        query_groupUid_eq: ""
      };
      this.reloadTable();
    },
    reloadTable() {
      this.handleTableChange(this.pagination, null, null, this.queryParam);
    },
    deleteById: function(id) {
      this.$http.get("/api/1.0/product/delete/" + id).then(res => {
        this.reloadTable();
      });
    },
    goToAdd() {
      this.$router.push({
        path: "/product/add"
      });
    },
    goToUpdate(id) {
      this.$router.push({
        path: "/product/update/" + id
      });
    },

    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    updateProduct(params) {
      this.$http.post("/api/1.0/product/update", params).then(res => {
        if (res.code === 200) {
          this.$message.info("更新成功");
        }
      });
    },
    handleUploadFileChange(info, record) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        if (info.file.response.code == 200) {
          const fileName = info.file.response.data;

          this.$http
            .post("/api/1.0/product/update", {
              id: record.id,
              picture: fileName
            })
            .then(res => {
              if (res.code === 200) {
                record.picture = fileName;
                this.$message.success(`${record.name}的封面图片上传成功！`);
              } else {
                this.$message.error(`${record.name}的封面图片上传失败！`);
              }
            });
        } else {
          this.$message.error(`${record.name}的封面图片上传失败！`);
        }
      } else if (info.file.status === "error") {
        this.$message.error(`文件上传失败`);
      }
    },
    getTaxFreeOrTaxPrice(product, priceType) {
      let price;
      this.productPriceList.forEach(item => {
        if (item.productId == product.id && item.priceType == priceType) {
          price = item.price;
          product[priceType] = item.price;
        }
      });
      return price;
    }
  }
};
</script>

<style scoped>
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0px;
}
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-advanced-search-form {
  padding: 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
</style>